export function scrollTo<E extends HTMLElement>(element: E) {
  const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
  const rect = element.getBoundingClientRect();
  window.scrollTo({
    top: scrollTop + rect.top - (window.innerHeight / 3),
    behavior: 'smooth',
  });
}
